import { WellCoord } from 'common/types/bundle';
import { Measurement, VolumeOrConcentration } from 'common/types/mix';

// These types must match the corresponding Go structs in the antha repo.

export enum PlateAssignmentMode {
  COMBINATORIAL = 'combinatorial',
  DESCRIPTIVE = 'descriptive',
}

export enum LiquidSortMode {
  CONCENTRATION = 'concentration',
  NONE = '',
}

export enum WellSortMode {
  BY_ROW = 'byRow',
  BY_COLUMN = 'byColumn',
}

export enum SortOrder {
  NONE = '',
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
}

export enum NamingMode {
  NONE = '',
  KEEP_NAME_OF_SPECIFIC_LAYER = 'keepNameOfSpecificLayer',
}

export type PlateAssignment = {
  plateType: string; // name; on deserialisation in core-antha this is converted to true PlateType
  assignmentMode: PlateAssignmentMode;
  plateLayers: PlateLayer[];
  totalVolume?: Measurement;
  diluentName?: string;
  replicates: number;
  namingPlateLayerID: string;
  namingMode: NamingMode;
};

export type PlateLayer = {
  id: string;
  name: string;
  wellSets: WellSet[];
  liquids: LiquidAssignment[];
  isReadOnly?: boolean;
};

export type LiquidAssignment = {
  wellSetID: string;
  liquidGroup?: string;
  liquidName?: string;
  sortBy?: LiquidSortMode;
  sortOrder?: SortOrder;
  subComponentName?: string;
  target: VolumeOrConcentration;
  existing?: {
    volume: Measurement;
    concentration?: Measurement;
  };
};

export type WellSet = {
  id: string;
  wells: WellCoord[];
  sortBy?: WellSortMode;
};

export type PlateNamesWithAssignment = {
  id: string;
  plateNames: string[];
  plateAssignment: PlateAssignment;
};
